import { Typography, CircularProgress, Card, CardContent } from "@mui/material";
import { harmony_ring_program_list_api } from "src/DAL/Login/Login";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { s3baseUrl } from "src/config/config";
import { useNavigate } from "react-router-dom";
import RecordNotFound from "src/components/RecordNotFound";
import RecentMembersTable from "src/components/_dashboard/RecentMembers";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function DashboardApp() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const fetchDashboardData = async () => {
    const result = await harmony_ring_program_list_api();
    if (result.code === 200) {
      return result;
    } else {
      throw new Error(result.message);
    }
  };

  const { data: inputs, isLoading } = useQuery({
    queryKey: ["dashboardData"],
    queryFn: fetchDashboardData,
    onError: (err) => {
      enqueueSnackbar(err.message, { variant: "error" });
    },
  });

  const dataProgram = inputs?.program || [];

  const handleClick = (value) => {
    navigate(`/dashboard/harmony-program/${value._id}`, {
      state: value,
    });
  };

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mt-4">
          <Typography className="welcome-back" variant="h4">
            Hi, Welcome back
          </Typography>
        </div>
        <div className="col-md-6 mt-4 d-flex align-items-center">
          <Card
            sx={{
              width: "100%",
              height: "100%",
              maxHeight: 300,
              display: "flex",
              borderRadius: 2,
              flexDirection: "column",
              boxShadow: 2,
            }}
          >
            <CardContent>
              <Typography
                variant="h6"
                sx={{ color: "#04abbb", fontWeight: "bold" }}
              >
                Harmony Ring Programmes
              </Typography>
              <Typography variant="body2" color="text.secondary">
                The following is the list of programmes for which the Harmony
                Ring feature is enabled.
              </Typography>
            </CardContent>

            {dataProgram && dataProgram.length > 0 ? (
              <>
                <List
                  dense
                  sx={{
                    overflowY: "auto",
                    flexGrow: 1,
                    px: 1,
                    pb: 2,
                  }}
                >
                  {dataProgram.map((program) => (
                    <ListItem
                      key={program._id}
                      onClick={() => handleClick(program)}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          size="small"
                          aria-label="go"
                          onClick={() => handleClick(program)}
                          sx={{ color: "#04abbb" }}
                        >
                          <ArrowForwardIosIcon
                            style={{
                              fontSize: "16px",
                            }}
                          />
                        </IconButton>
                      }
                      disablePadding
                    >
                      <ListItemButton>
                        <ListItemAvatar>
                          <Avatar
                            alt={program.title}
                            src={s3baseUrl + program.program_images.thumbnail_1}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          secondaryTypographyProps={{ color: "#FF9800" }}
                          primary={program?.title}
                          secondary={`Members: ${program?.members_with_uncompleted_workouts}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </>
            ) : (
              <RecordNotFound title="Programmes" class={true} />
            )}
          </Card>
        </div>
        <div className="col-md-6 mt-4 d-flex align-items-center">
          <RecentMembersTable recentMember={inputs?.recent_member || []} />
        </div>
      </div>
    </div>
  );
}
